import { ValidationSchema, Tuple } from '../../../types';
import { ProjectItemModel } from '../../../api/models/rndApplication/ProjectItemModel';
import * as validatorRules from '../../validatorRules.json';
import { textMandatory, postcodeOptional, textAreaBetweenMinAndMax, fieldRequiredValidator } from '../../validationFunctions';
import { projectNameValidator } from './name';
import { referenceDescriptionValidator } from './referenceDescription';
import { IsAdvancedOrOverseasFindingNotEmpty } from './advancedOrOverseasFinding';
import { prjFindingRefNumHardValidator } from './findingReferenceNumber';
import { addressValidator } from '../../../validation/common/address';
import { projectDurationSoftValidator, projectDurationHardValidator } from './projectDuration';
import { maxCurrencyLength, mandatoryCurrency } from '../../validationFunctions/commonCurrencyInput';
import { AddressModel } from '../../../api/models';
import { isEmpty } from 'lodash';

export const fieldRequireValidator: Tuple<(value: any) => boolean, string>[] = [
    [textMandatory, validatorRules.BR1_Mandatory_Field.FieldMessage],
];

const triggerHardAddressValidation = (value: Partial<AddressModel>) => {
    return (!isEmpty(value.addressLine1) ||
        !isEmpty(value.addressLine2) ||
        !isEmpty(value.localityName) ||
        !isEmpty(value.postcode) ||
        !isEmpty(value.state));
};

export const projects: ValidationSchema<Partial<ProjectItemModel>> = (values: Partial<ProjectItemModel>) => {
    return {
        name: projectNameValidator(values),
        referenceDescription: referenceDescriptionValidator,
        findingReferenceNumber: prjFindingRefNumHardValidator(values),
        duration: projectDurationHardValidator(values),
        moneySpent: [maxCurrencyLength(12)],
        objectives: textAreaBetweenMinAndMax('none', 'objectives', 2, 4000),
        documentsKept: textAreaBetweenMinAndMax('none', 'documentsKept', 2, 4000),
        plantAndFacilitiesDescription: textAreaBetweenMinAndMax('none', 'plantAndFacilitiesDescription', 2, 4000),
        feedstockInputsSpent: [maxCurrencyLength(12)],
        plantAddressLookup: addressValidator(() =>
            triggerHardAddressValidation(values.plantAddressLookup!) && values.isPlantAddressSameAsMainBusinessAddress === 'No'),
        postcode: postcodeOptional,
        explainWhyCompanyIsBeneficiary: textAreaBetweenMinAndMax('none', 'explainWhyCompanyIsBeneficiary', 2, 4000),
    };
};

export const projectsSoft: ValidationSchema<Partial<ProjectItemModel>> = (values: Partial<ProjectItemModel>) => {
    const hardValidation = projects(values);
    return {
        ...hardValidation,
        taxIncentiveInfluence: fieldRequiredValidator,
        advancedOrOverseasFinding: [
            [(value: 'Yes' | 'No' | undefined) => IsAdvancedOrOverseasFindingNotEmpty(value, values), validatorRules.BR1_Mandatory_Field.FieldMessage],
        ],
        duration: projectDurationSoftValidator(values),
        moneySpent: mandatoryCurrency(),
        objectives: fieldRequireValidator,
        findingReferenceNumber: fieldRequireValidator,
        feedstockInputsSpent: mandatoryCurrency(),
        postcode: fieldRequireValidator,
        documentsKept: fieldRequiredValidator,
        isPlantAddressSameAsMainBusinessAddress: fieldRequiredValidator,
        plantAddressLookup: addressValidator(() => values.isPlantAddressSameAsMainBusinessAddress === 'No'),
        plantAndFacilitiesDescription: fieldRequiredValidator,
        anzsrcDivision: fieldRequireValidator,
        anzsrcGroup: fieldRequireValidator,
        explainWhyCompanyIsBeneficiary: fieldRequiredValidator,
    };
};
